import { ReactElement, ReactNode } from 'react';
import { useTheme, Divider, Grid, Stack, Typography, Box } from '@mui/material';
import { PageSection } from '../PageSection/PageSection';

interface PanelProps {
  panelTitle: string;
  panelSummary: string;
  panelButton?: ReactElement;
  children?: ReactNode;
  'data-testid'?: string;
  disableSpacing?: boolean;
  panelChip?: ReactElement;
}

export function Panel({ ...props }: PanelProps): ReactElement {
  const theme = useTheme();

  return (
    <PageSection data-testid={props['data-testid']}>
      <Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography variant="h6" fontFamily="KingspanBrownTT-Bold">
                {props.panelTitle}
              </Typography>
              <Box>{props.panelChip}</Box>
            </Box>
            <Typography variant="body2" color={theme.palette.grey[500]}>
              {props.panelSummary}
            </Typography>
          </Stack>
          <Box sx={{ flexShrink: 0 }}>{props.panelButton}</Box>
        </Stack>

        <Divider />

        <Grid container spacing={props.disableSpacing ? undefined : 2}>
          {props.children}
        </Grid>
      </Stack>
    </PageSection>
  );
}
